import { IDropdownStyles, ITheme } from '@fluentui/react';

export const dropdownStyles = (
  isDarkMode: boolean,
  theme: ITheme
): Partial<IDropdownStyles> => ({
  dropdownItemSelected: {
    transition: 'none',
    ':hover': {
      backgroundColor: isDarkMode
        ? theme.palette.themeDark
        : theme.palette.themeTertiary,
      color: isDarkMode
        ? theme.palette.neutralLight
        : theme.palette.neutralDark,
    },
    backgroundColor: isDarkMode
      ? theme.palette.themeTertiary
      : theme.palette.themeDarker,
    color: isDarkMode ? theme.palette.neutralDark : theme.palette.neutralLight,
  },
  dropdownItem: {
    transition: 'none',
    ':hover': {
      backgroundColor: isDarkMode
        ? theme.palette.themeDark
        : theme.palette.themeTertiary,
      color: isDarkMode
        ? theme.palette.neutralLight
        : theme.palette.neutralDark,
    },
  },
});
